export const DEFAULT_LINE_WIDTH = 2;
export const DEFAULT_LINE_GAP = 2;
